import React from "react";
import ReactDOM from "react-dom";
import { ComponentType } from "react";
import "../styles/main.scss";
import { createRoot } from "react-dom/client";
import { off } from "process";
import { handleFrontend } from "./base";

const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList" || mutation.type === "attributes") {
      // renderComponents();
    }
  }
});

const COMPONENT_MAP: Record<string, ComponentType<any>> = {
  Button: React.lazy(() => import("../components/Button/Button")),
  Minimoteur: React.lazy(() => import("../components/Minimoteur/Minimoteur")),
  Moteur: React.lazy(() => import("../components/Moteur/Moteur")),
  Complement: React.lazy(() => import("../components/Complement/Complement")),
};

function lazyLoadComponent(componentName: string) {
  return React.lazy(() =>
    import(`../components/${componentName}/${componentName}`)
  );
}

function renderComponents() {
  const elements = document.querySelectorAll(".react-component");

  elements.forEach((el) => {
    const currentIdentifier = generateComponentIdentifier(el);
    const previousIdentifier = el.getAttribute("data-previous-identifier");

    if (currentIdentifier === previousIdentifier) {
      return; // Skip re-rendering if the component hasn't changed
    }

    el.setAttribute("data-previous-identifier", currentIdentifier); // Store the identifier for next time

    const componentName = el.getAttribute("data-component");
    const propsString = el.getAttribute("data-props");

    if (componentName) {
      const Component: React.ComponentType<any> = COMPONENT_MAP[componentName];
      // const Component = lazyLoadComponent(componentName);

      const root = createRoot(el);
      if (propsString === null) {
        root.render(<Component />);
      } else {
        const props = JSON.parse(propsString);
        root.render(<Component {...props} />);
      }
    }
  });
}

let previousComponentsState = "";

function generateComponentIdentifier(el: Element): string {
  return el != null
    ? (el?.getAttribute("data-component") ?? "") +
    (el?.getAttribute("data-props") ?? "")
    : "";
}

function pollForChanges() {
  console.log("pollForChanges");
  const currentComponentsState = Array.from(
    document.querySelectorAll(".react-component")
  )
    .map(generateComponentIdentifier)
    .join("");

  if (previousComponentsState !== currentComponentsState) {
    renderComponents();
    previousComponentsState = currentComponentsState;
  }
}

let isComponentsRendered = false;

function pollForComponentRender() {
  const editor = document.querySelector(".edit-post-visual-editor");
  if (editor && editor.querySelector(".react-component")) {
    renderComponents();
    isComponentsRendered = true;
  }
}

// Call the function to render components
window.addEventListener("load", () => {
  handleFrontend();
  if (document.querySelector(".edit-post-visual-editor, .is-root-container")) {
    const intervalId = setInterval(() => {
      pollForComponentRender();
      if (isComponentsRendered) {
        clearInterval(intervalId); // Stop polling when components are rendered
        startPolling(); // Start the original polling for changes
      }
    }, 500); // Check every 0.5 seconds
  } else {
    renderComponents();
    startPolling();
  }
});

function startPolling() {
  setInterval(pollForChanges, 500); // Check every 0.5 seconds
}
